export default __webpack_public_path__ + "static/media/inspect-macbook-1.5f3b7d4e.png";